import React, { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  Col,
  Layout,
  Row,
  Space,
  Typography,
  Modal,
} from "antd";
import "./footer.css";
import { useHistory, useLocation, useParams } from "react-router-dom";
import uuid from "react-uuid";
import AddDetail from "../sectionInsight/modal/AddDetail";
import SaveDashboardModal from "./SaveDashboardModal";
import { useSelector, useDispatch } from "react-redux";
import { setModalVisible } from "../../../redux/actions/templates/AddSection";
import {
  setAllSelectedCheckbox,
  setIsSelected,
  setupdatedGraphData,
  setWidgetList,
} from "../../../redux/actions/widget/widget";
import {
  callNotification,
  clearGlobalvariables,
  deepCopy,
  getPaneIndex,
} from "../../../redux/constants";

import {
  setClearGraphDetails,
  setGraphBrands,
} from "../../../redux/actions/dashboard/Welcome";
import { setWelcomePage } from "../../../redux/actions/dashboard/Welcome";
import {
  setAddSection,
  setFooterValue,
  setTemplateDetails,
} from "../../../redux/actions/section/section";
import { setIsEditTemplate } from "../../../redux/actions/section/section";
import { setWidgetMetaData } from "../../../redux/actions/WidgetMaker/WidgetAPI";
import {
  setWidgetLibraryCheckedList,
  setNewReplaceWidgetId,
} from "../../../redux/actions/WidgetMaker/WidgetLibrary";
import { setOptionHighChart } from "../../../redux/actions/HighChart";

const { Text } = Typography;

const Footer = ({ isSaveTemplate, setIsSaveTemplate, tabKey }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { id } = useParams();
  const isSelected = useSelector((state) => state.Widget.isSelected);
  const { state } = location;
  const [isDashboardModalOpen, setIsDashboardModalOpen] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [isWidgetAdded, setIsWidgetAdded] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDashboard, setIsDashboardSave] = useState(false);
  const modalVisible = useSelector((state) => state.addSection.modalVisible);
  const footerValue = useSelector((state) => state.Section.footerValue);
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const templateResponseId = useSelector(
    (state) => state.ApiCall.templateResponseId
  );
  const templateDetails = useSelector((state) => state.Section.templateDetails);

  const Section = useSelector((state) => state.Section.addSection);

  const sectionDetails = useSelector((state) => state.Section.sectionDetails);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const isEditTemplate = useSelector((state) => state.Section.isEditTemplate);
  const allSelectedCheckbox = useSelector(
    (state) => state.Widget.allSelectedCheckbox
  );
  const widgetList = useSelector((state) => state.Widget.widgetList);

  const graphResponse = useSelector((state) => state.apiCall.graphResponse);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const ticketTAT = useSelector((state) => state.Welcome.ticketTAT);

  const aggregateResponse = useSelector(
    (state) => state.apiCall.aggregateResponse
  );
  const predefined_widgets_data = useSelector(
    (state) => state.WidgetAPI.predefined_widgets_data?.data
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );

  //widget maker
  const widgetLibrarycheckedList = useSelector(
    (state) => state.WidgetLibrary.widgetLibrarycheckedList
  );

  const openModal = (e) => {
    if (footerValue?.template) {
      footerValue?.template && setIsSaveTemplate(true);
      footerValue?.template &&
        !templateDetails?.templateName &&
        callNotification("Kindly add dashboard name", "info");
      templateDetails?.templateName &&
        footerValue?.template &&
        Section[0]?.data?.length === 0 &&
        callNotification("Kindly select atleast one widget", "info");
      templateDetails?.templateName &&
        Section[0]?.data?.length !== 0 &&
        setIsDashboardModalOpen(true);
    } else if (footerValue?.section) {
      widgetList?.length > 0 || widgetLibrarycheckedList?.length > 0
        ? dispatch(setModalVisible(true))
        : setIsDashboardSave(true);
    }
  };
  let newlyAdded =
    widgetLibrarycheckedList &&
    widgetLibrarycheckedList?.length > 0 &&
    widgetLibrarycheckedList?.filter((el) => typeof el === "string")?.length > 0
      ? widgetLibrarycheckedList?.filter((el) => typeof el === "string")
      : widgetList?.length > 0
      ? widgetList
      : [];
  const handleModal = () => {
    let index = getPaneIndex(panes, activeKey);

    (footerValue?.section ||
      footerValue?.widget ||
      footerValue?.replaceThisWidget) &&
      newlyAdded?.length === 0 &&
      callNotification("Kindly select atleast one widget", "info");

    !footerValue?.template &&
      !footerValue?.widget &&
      footerValue?.section &&
      (widgetList?.length > 0 || widgetLibrarycheckedList?.length > 0) &&
      dispatch(setModalVisible(true));

    if (
      (footerValue?.widget || footerValue?.replaceThisWidget) &&
      newlyAdded?.length > 0
    ) {
      let template_id = panes[index]?.template_id;
      const sectionValue = Section.find((el) => el.id === state?.section_id);
      const sectionIndex = Section.findIndex(
        (el) => el.id === state?.section_id
      );
      let deepCopyOfPredefined_widgets_data = predefined_widgets_data
        ? deepCopy(predefined_widgets_data)
        : predefined_widgets_data;
      let pageInsightCheck =
        widgetLibrarycheckedList?.length > 0
          ? deepCopyOfPredefined_widgets_data?.findIndex((el) =>
              widgetLibrarycheckedList?.includes(el?.widget_id)
            )
          : -1;

      let widgetList1 = [...widgetList];
      if (footerValue?.widgetMaker && pageInsightCheck === -1) {
        let array = widgetLibrarycheckedList?.filter((el) => {
          if (typeof el === "string") {
            return el;
          }
        });
        if (footerValue?.replaceThisWidget && newlyAdded?.length > 0) {
          let widgetObj = {
            widget_id: newlyAdded,
            index: index,
            template_id: template_id,
            sectionValue: sectionValue,
            sectionIndex: sectionIndex,
            singleBrands: brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            templateDetails: templateDetails,
            Section: Section,
            graphConditionConfig: graphConditionConfig,
            addWidget: false,
            replaceThisWidget: footerValue?.replaceThisWidget,
          };
          // clear the new dispatch for widget_index
          dispatch(setWidgetMetaData(authParams, widgetObj));
        } else {
          let widgetObj = {
            widget_id: array,
            index: index,
            template_id: template_id,
            sectionValue: sectionValue,
            sectionIndex: sectionIndex,
            singleBrands: brands,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            templateDetails: templateDetails,
            Section: Section,
            graphConditionConfig: graphConditionConfig,
            addWidget: true,
          };

          dispatch(setWidgetMetaData(authParams, widgetObj));
        }
      } else {
        // dispatch(setOptionHighChart({}));
        if (sectionValue) {
          let widgetData = sectionValue?.data ? [...sectionValue?.data] : [];
          let deepCopyOfPredefined_widgets_data = predefined_widgets_data
            ? deepCopy(predefined_widgets_data)
            : predefined_widgets_data;
          let predefinedWidgetsArray = [];
          Array.isArray(widgetLibrarycheckedList) &&
            widgetLibrarycheckedList?.forEach((id) => {
              let indOfWidget = deepCopyOfPredefined_widgets_data?.findIndex(
                (el) => el?.widget_id === id
              );
              if (indOfWidget !== -1) {
                predefinedWidgetsArray?.push(
                  deepCopyOfPredefined_widgets_data?.[indOfWidget]
                );
              }
            });
          let section = [
            {
              id: sectionValue?.id ? sectionValue?.id : uuid(),
              name: sectionValue?.name ? sectionValue?.name : "",
              description: sectionValue?.description
                ? sectionValue?.description
                : "",
              isSectionAdded: sectionValue?.isSectionAdded
                ? sectionValue?.isSectionAdded
                : false,
              isWidgetAdded: sectionValue?.isWidgetAdded
                ? sectionValue?.isWidgetAdded
                : true,
              data:
                predefinedWidgetsArray?.length > 0
                  ? [...widgetData, ...predefinedWidgetsArray]
                  : [...widgetData, ...widgetList1],
              duration: sectionValue?.duration,
            },
          ];
          let newObj = {
            widgetList:
              predefinedWidgetsArray?.length > 0
                ? predefinedWidgetsArray
                : widgetList1,
            section_index: sectionIndex,
            templateDetails: templateDetails,
            newWidget: true,
            authParams: authParams,
            global_brands: graphDetail?.brands
              ? graphDetail?.brands
              : templateDetails?.templateBrands
              ? templateDetails?.templateBrands
              : null,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            global_duration: templateDetails?.templateDuration
              ? templateDetails?.templateDuration
              : null,
            global_filters: templateDetails?.templateFilters
              ? templateDetails?.templateFilters
              : [],
            singleBrands: Allbrands,
            graphConditionConfig: graphConditionConfig,
          };
          dispatch(setAddSection(Section, section, false, newObj));
        } else if (
          // to replace with pre-defined widgets
          footerValue?.replaceThisWidget
        ) {
          let replaceToWidget;
          for (let i = 0; i < predefined_widgets_data?.length; i++) {
            if (predefined_widgets_data?.[i]?.widget_id === newlyAdded?.[0]) {
              replaceToWidget = predefined_widgets_data?.[i];
            } else if (widgetList?.length > 0) {
              replaceToWidget = widgetList?.[0];
            }
          }
          let newSec = deepCopy(Section);
          for (let i = 0; i < newSec?.length; i++) {
            for (let j = 0; j < newSec?.[i]?.data?.length; j++) {
              if (
                newSec?.[i]?.data?.[j]?.widget_id ===
                footerValue?.replaceThisWidget
              ) {
                // replace widget data in same index
                newSec[i].data[j] = replaceToWidget;
                dispatch(setAddSection(Section, newSec, "update"));
                dispatch(setNewReplaceWidgetId(replaceToWidget?.widget_id));
                // dispatch null to the new widget_index
              }
            }
          }
        }
      }

      dispatch(setWidgetList([]));
      dispatch(setWidgetLibraryCheckedList([]));
      dispatch(setupdatedGraphData({}));
      dispatch(setIsSelected({}));
      if (sectionDetails?.sectionKey === "CreateTemplate") {
        // history.push(`/create-dashboard`);
        // PIN DEV Add widget CreateTemplate FLOW
        history.goBack();
      } else if (sectionDetails?.sectionKey === "edit_template") {
        // history.push(`/edit-dashboard/${template_id}`);
        // PIN DEV Add widget edit_template FLOW
        history.goBack();
      }
      dispatch(
        setFooterValue({
          replaceThisWidget: null,
          section: false,
          widget: false,
          template: true,
        })
      );
      dispatch(setWelcomePage(true));
      dispatch(setClearGraphDetails()); //to clear graph details(x,y,split,filter etc)
    }

    dispatch(setAllSelectedCheckbox(false));
    if (footerValue?.widget && newlyAdded?.length > 0) {
      dispatch({ type: "SET_WIDGET_LIBRARY_LIST", payload: null });
    }
    const timer = setTimeout(() => {
      let scrollToBottom = document.documentElement.scrollHeight;
      window.scrollBy(0, scrollToBottom);
    }, 200);

    return () => {
      clearTimeout(timer);
    };
  };

  useEffect(() => {
    if (
      templateResponseId?.template_id &&
      !footerValue?.dashboard &&
      !footerValue?.template &&
      !footerValue?.section &&
      !footerValue?.widget &&
      !footerValue?.replaceThisWidget
    ) {
      history.push(`/dashboard`, { onGraphPage: false });
      dispatch(
        setFooterValue({ section: false, widget: false, template: false })
      );
    }
  }, [templateResponseId]);

  const handleScroll = () => {
    const bottom =
      Math.ceil(window.innerHeight + window.scrollY) >=
      document.documentElement.scrollHeight;

    if (window.scrollY > 100) {
      setIsBottom(true);
    } else {
      setIsBottom(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handelAllClick = (e) => {
    if (e.target.checked) {
      //if checked then setAllSelectedCheckbox to true

      let select = isSelected;
      let arr = [];
      let data = graphResponse?.result?.sort((a, b) =>
        a?.span === "full" && b?.span === "half"
          ? -1
          : a?.span === b?.span
          ? 0
          : 1
      );
      let aggregateData = aggregateResponse?.result;
      if (
        aggregateResponse &&
        aggregateData &&
        select["50"] !== null &&
        select["50"] !== undefined
      ) {
        select["50"] = true;
        arr?.push({
          widget_name: aggregateData?.widget_name,
          type: aggregateData?.type,
          graph_type: aggregateData?.graph_type,
          is_custom: false,
          primary: graphDetail?.first,
          secondary: graphDetail?.second,
          splits: graphDetail?.split,
          filters: graphDetail?.filter,
          base: graphDetail?.base,
          id: aggregateData?.id,
          datatype: aggregateData?.datatype,

          data: aggregateData?.data,

          description: aggregateData?.description,

          graph_duration: graphDetail?.duration,
          graph_brands: graphDetail?.brands,
          widget_id: uuid(),
        });
      }
      Object.keys(select)?.map((el, i) => {
        select[el] = true;
        if (el !== 50 && i < graphResponse?.result?.length && data[i]?.type) {
          arr?.push({
            widget_name: data[i]?.widget_name,
            type: data[i]?.type,
            graph_type: data[i]?.graph_type,
            is_custom: false,
            primary: graphDetail?.first,
            secondary: graphDetail?.second,
            splits: graphDetail?.split,
            filters: graphDetail?.filter,
            base: graphDetail?.base,
            id: data[i]?.id,
            datatype: data[i]?.datatype,
            span: data[i]?.span,
            data: data[i]?.data,
            stacked: data[i]?.stacked,
            description: data[i]?.description,
            x_label: data[i]?.x_label,
            y_label: data[i]?.y_label,
            graph_duration: graphDetail?.duration,
            graph_brands: graphDetail?.brands,
            differential: data[i]?.differential,
            percent: data[i]?.percent,
            widget_id: uuid(),
            log:
              graphDetail?.aiLogScale !== null
                ? graphDetail?.aiLogScale
                : data[i]?.log,
          });
        }
      });

      dispatch(setWidgetList(arr));

      dispatch(setAllSelectedCheckbox(e.target.checked));
      dispatch(setIsSelected(select));
    } else if (!e.target.checked) {
      //if unchecked the setAllSelectedCheckbox to false and clear widget list
      let select = isSelected;
      Object.keys(select)?.map((el) => {
        select[el] = false;
      });
      dispatch(setAllSelectedCheckbox(false));
      dispatch(setIsSelected(select));
      dispatch(setWidgetList([]));
      dispatch(setWidgetLibraryCheckedList([]));
    }
  };

  const handleCancelYes = () => {
    dispatch(setIsEditTemplate(false));
    if (footerValue?.section || footerValue?.widget) {
      // Currently not going inside
      // On Section based cancel button of create dashboard to dashboard path
      history.push(`/create-dashboard`);
      dispatch(setClearGraphDetails());
      dispatch(setWelcomePage(true));

      dispatch(setAllSelectedCheckbox(false));
      dispatch(setWidgetList([]));
      dispatch(setWidgetLibraryCheckedList([]));
      dispatch(setupdatedGraphData({}));
      dispatch(setIsSelected({}));
      dispatch(
        setFooterValue({ section: false, widget: false, template: true })
      );
    } else {
      dispatch(setOptionHighChart(null));
      dispatch(setTemplateDetails(null));
      dispatch(setGraphBrands(null, graphDetail));
      // history.push(`/dashboard`, { onGraphPage: false });
      // PIN DEV On cancel button of edit dashboard to dashboard
      history.goBack();
      dispatch(
        setFooterValue({
          section: false,
          widget: false,
          template: false,
          dashboard: true,
        })
      );
    }
  };

  const handleModalYes = () => {
    clearGlobalvariables();
    dispatch(setTemplateDetails(null));
    setIsModalVisible(false);
    handleCancelYes();
  };

  const goToWelcomePage = () => {
    dispatch(setWelcomePage(true));
    dispatch(setClearGraphDetails());
    dispatch(setWidgetList([]));
    dispatch(setupdatedGraphData({}));
    dispatch(setIsSelected({}));
    dispatch(setAllSelectedCheckbox(false));

    dispatch(
      setFooterValue({
        section: footerValue?.section,
        widget: footerValue?.widget,
        template: false,
        widgetMaker: true,
      })
    );
  };
  const handleBackWelcome = () => {
    // footerValue?.dashboard
    //   ? history.push("/dashboard", { isGraph: true })
    //   : isEditTemplate
    //   ? history.push(`/edit-dashboard/${sectionDetails?.template_id}`)
    //   : history.push("/create-dashboard");

    // PIN DEV FOOTER on cancle click from dashboard widget list to edit dashboard or create dashboard
    footerValue?.dashboard
      ? history.goBack()
      : isEditTemplate
      ? history.goBack()
      : history.goBack();

    dispatch(setClearGraphDetails());
    dispatch(setWelcomePage(true));
    dispatch(setAllSelectedCheckbox(false));
    dispatch(setWidgetList([]));
    dispatch(setWidgetLibraryCheckedList([]));
    dispatch(setupdatedGraphData({}));
    dispatch(setIsSelected({}));
    dispatch(setFooterValue({ section: false, widget: false, template: true }));
  };
  const handleOk = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  let condition = graphResponse?.result
    ? graphResponse?.result?.length +
      (aggregateResponse && aggregateResponse?.status !== "error" ? 1 : 0)
    : aggregateResponse && aggregateResponse?.status !== "error"
    ? 1
    : 0;
  return (
    <>
      <Layout.Footer
        style={{ position: "sticky", zIndex: "1", bottom: "0" }}
        className="p-0"
      >
        <div className="bg-white box-shadow p-3 ml-15 mr-15 bg-body rounded-top-footer">
          <Row justify="center" align="middle">
            <Col span={12}>
              {state?.onGraphPage && !footerValue?.widgetMaker && !tabKey && (
                <Space className="pl-0" size={80}>
                  {!ticketTAT && (
                    <Checkbox
                      onChange={(e) => handelAllClick(e)}
                      checked={
                        allSelectedCheckbox
                          ? true
                          : condition === widgetList?.length
                          ? true
                          : false
                      }
                    >
                      <Text className="text-Darkgray">
                        Select All (
                        {graphResponse?.result
                          ? graphResponse?.result?.length +
                            (aggregateResponse &&
                            aggregateResponse?.status !== "error"
                              ? 1
                              : 0)
                          : aggregateResponse &&
                            aggregateResponse?.status !== "error"
                          ? 1
                          : 0}
                        )
                      </Text>
                    </Checkbox>
                  )}
                  <span className="text-Darkgray">
                    {allSelectedCheckbox
                      ? ticketTAT
                        ? ticketTAT?.length
                        : graphResponse?.result?.length +
                          (aggregateResponse &&
                          aggregateResponse?.status !== "error"
                            ? 1
                            : 0)
                      : widgetList?.length}{" "}
                    Selected
                  </span>
                </Space>
              )}
              {footerValue?.template && (
                <Space size={[50]} className="pl-0">
                  {/* <div>
									<img src={filterSmall} alt="filter-icon" />
									<span>
										Global Filter {""}
										<span
											className="rounded-circle"
											style={{
												height: "2rem",
												width: "2rem",
												backgroundColor: "#185EDF",
												borderRadius: "50%",
												textAlign: "center",
												display: "inline-block",
												color: "#fff",
											}}
										>
											3
										</span>
									</span>
								</div> */}
                  {isWidgetAdded ? (
                    <div>
                      <span style={{ color: "red" }}>
                        Widget cannot be empty *
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </Space>
              )}
            </Col>
            <Col className="text-right" span={12}>
              <Space>
                <Button
                  onClick={
                    footerValue?.widget && !footerValue?.widgetMaker
                      ? goToWelcomePage
                      : footerValue?.widget && footerValue?.widgetMaker
                      ? handleBackWelcome
                      : footerValue?.section && !footerValue?.widgetMaker
                      ? goToWelcomePage
                      : footerValue?.section && footerValue?.widgetMaker
                      ? handleBackWelcome
                      : footerValue?.template && isEditTemplate
                      ? handleOk
                      : footerValue?.template && !isEditTemplate && handleOk
                  }
                  className="bg-black btn_Clear"
                  type="default"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() =>
                    footerValue?.template
                      ? openModal()
                      : (footerValue?.section ||
                          footerValue?.widget ||
                          footerValue?.replaceThisWidget) &&
                        handleModal()
                  }
                  type="primary"
                  className="ant-btn-primary_blue"
                >
                  {footerValue?.replaceThisWidget
                    ? "Replace Widget"
                    : footerValue?.widget
                    ? "Add Widget"
                    : footerValue?.section
                    ? "Add Section"
                    : footerValue?.template && isEditTemplate
                    ? "Save Changes"
                    : footerValue?.template &&
                      !isEditTemplate &&
                      "Save Dashboard"}
                </Button>
              </Space>
            </Col>
          </Row>
        </div>
      </Layout.Footer>
      {(widgetList?.length > 0 || widgetLibrarycheckedList?.length > 0) && (
        <AddDetail
          setIsSaveTemplate={setIsSaveTemplate}
          isWidget={Section[0]?.data?.length === 0 ? true : false}
          isSaveTemplate={isSaveTemplate}
          isAddDetail={modalVisible}
          allSelectedCheckbox={allSelectedCheckbox}
          selectedWidgets={widgetList?.length}
        />
      )}

      <Modal
        title=""
        closable={false}
        visible={isModalVisible}
        className={`warning_popup pb-0 ${
          authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
        }`}
        footer={
          <>
            <Button onClick={() => handleCancel()} className="btn_Clear">
              No
            </Button>
            <Button
              type="primary"
              className="ant-btn-primary_blue"
              onClick={() => handleModalYes()}
            >
              Yes
            </Button>
          </>
        }
      >
        <div className="mb-0 text_heading-Slab text-transform__none">
          Are you sure you want to exit?
        </div>
        <div className="text_regular">
          After exiting your data will be lost, whatever you have configured
          here
        </div>
      </Modal>
      {footerValue?.template && isDashboardModalOpen && (
        <SaveDashboardModal
          isDashboardModalOpen={isDashboardModalOpen}
          setIsDashboardModalOpen={setIsDashboardModalOpen}
          setIsDashboardSave={setIsDashboardSave}
          isDashboard={isDashboard}
          setIsSaveTemplate={setIsSaveTemplate}
          isEditTemplate={isEditTemplate}
        />
      )}
    </>
  );
};

export default Footer;
